<template>
  <div class="content resize">
    <form id="vl">
      <h1 class="page_title">가상계좌 신청내역</h1>
      <div class="content_box">
        <table class="tbl_search">
          <colgroup>
            <col width="150px">
            <col width="150px">
            <col width="250px">
          </colgroup>
          <tbody>
            <tr>
              <td>
                <input type="radio" id="tab01-ex1" name="tab01-exim" v-model="params.eiCatCd" :value="'O'" @change="changeCalcEiCatCd()">
                <label for="tab01-ex1"><span></span>{{ $t('msg.SETT010T010.001') }}</label>

                <input type="radio" id="tab01-im1" disabled name="tab01-exim" v-model="params.eiCatCd" :value="'I'" @change="changeCalcEiCatCd()">
                <label for="tab01-im1"><span></span>{{ $t('msg.SETT010T010.002') }}</label>
              </td>
              <td class="pr5">
                <select v-model="params.dtKnd">
                  <option value="VT">가상계좌 발행일</option>
                  <option value="BL">{{ $t('msg.SETT010T010.039') }} <!-- B/L No. --> </option>
                </select>
              </td>
              <td colspan="2" class="pl0">
                <div v-if="params.dtKnd === 'BL'">
                  <input type="text" style="width:200px" v-model.trim="params.blNo" @keyup.enter="searchData" @input="params.blNo=params.blNo.toUpperCase()">
                </div>
                <div v-if="params.dtKnd === 'IV'">
                  <input type="text" style="width:200px" v-model.trim="params.invNo" @keyup.enter="searchData" @input="params.blNo=params.blNo.toUpperCase()">
                </div>
                <div v-if="params.dtKnd === 'VT'">
                  <e-date-range-picker
                    :id="'fromDtToDt'"
                    :term-type="termType"
                    :show-term-type="['01', '02', '03', '04']"
                    :sdate="params.sdate"
                    :edate="params.edate"
                    @change="changeDateRange"
                  />
                </div>
              </td>
              <td class="text_right">
                <a class="button blue sh" @click="searchData()">{{ $t('msg.CMBA100.00120') }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="content_box mt10">
        <div class="flex_box">
          <span class="tot_num">{{ $t('msg.FARE020T010.014') }} : {{ total }}</span>
        </div>
        <div id="realgrid" :style="`width:100%; height:${gridHeight}px;`" />
      </div>
    </form>
    <div id="layerPop">
      <win-layer-pop class="inv_ongoing_list_popup">
        <component
          v-if="popupComponent"
          :is="popupComponent"
          @close="closeInvPopup"
          @callback="popupCallback"
          :parent-info="popupParams"
        />
      </win-layer-pop>
    </div>
  </div>
</template>

<script>
import { createGrid } from '@/plugins/realgridUtil'
import EDatePicker from '@/components/common/EDatePickerCustom'
import EDateRangePicker from '@/components/common/EDateRangePicker'
import EInputNumber from '@/components/common/EInputNumber'
import { rootComputed, rootMethods } from '@/store/helpers'
import CalcIssue from '@/api/rest/settle/calcIssue'
import vtlAcc from '@/api/rest/settle/vtlAcc'
import JSZip from 'jszip'

let gridView = null
let provider = null

export const fields = [
  { fieldName: 'vaAccntNo', dataType: 'text' },
  { fieldName: 'bascNo', dataType: 'text' },
  { fieldName: 'invIssNo', dataType: 'text' },
  { fieldName: 'issDt', dataType: 'datetime', datetimeFormat: 'yyyyMMddHHmm' },
  { fieldName: 'curCd', dataType: 'text' },
  { fieldName: 'locAmt', dataType: 'number' },
  { fieldName: 'rcvCpltYn', dataType: 'text' },
  { fieldName: 'apvStsCd', dataType: 'text' },
  { fieldName: 'vaAccntCd', dataType: 'text' },
  { fieldName: 'acctStsCd', dataType: 'text' },
  { fieldName: 'apiSeq', dataType: 'text' },
  { fieldName: 'suprInvIssNo', dataType: 'text' },
  { fieldName: 'reqRsps', dataType: 'text' },
  { fieldName: 'vaKrwAmt', dataType: 'text' },
  { fieldName: 'vaUsdAmt', dataType: 'text' },
  { fieldName: 'vaKrwRcvYn', dataType: 'text' },
  { fieldName: 'vaUsdRcvYn', dataType: 'text' }
]

export const columns = [
  { name: 'issDt', fieldName: 'issDt', type: 'datetime', datetimeFormat: 'yyyy.MM.dd HH:mm', header: '요청 일시', editable: false, width: 80 },
  {
    name: 'vaAccntNo',
    fieldName: 'vaAccntNo',
    type: 'text',
    header: '가상계좌번호(은행)',
    editable: false,
    width: 180
  },
  {
    name: 'bascNo',
    fieldName: 'bascNo',
    type: 'text',
    header: 'B/L No.',
    editable: false,
    width: 100,
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
        const idx = cell.index.dataRow
        const html = vmAppVaAll.vaList[idx].bascNo || ''
        return html
      }
    }
  },
  {
    name: 'invIssNo',
    fieldName: 'invIssNo',
    type: 'text',
    header: 'Invoice No.',
    editable: false,
    width: 80,
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
        const idx = cell.index.dataRow
        const html = []
        const bascNo = vmAppVaAll.vaList[idx].bascNo || ''
        const invNo = vmAppVaAll.vaList[idx].invIssNo || ''
        const vaKrwAmt = vmAppVaAll.vaList[idx].vaKrwAmt || ''
        const vaUsdAmt = vmAppVaAll.vaList[idx].vaUsdAmt || ''
        const apvStsCd = vmAppVaAll.vaList[idx].apvStsCd || ''
        if (apvStsCd === '취소' || apvStsCd === '거절') {
          html.push(`${invNo}`) //
        } else {
          html.push(`<a style="display: block; cursor:pointer;" class="link" onclick="vmAppVaAll.combineInvoicePopCall('${bascNo}', 'O', false, '${vaKrwAmt}', '${vaUsdAmt}', '${invNo}')">${invNo}</a>`) //
        }
        return html
      }
    }
  },
  { name: 'curCd', fieldName: 'curCd', type: 'text', header: 'Currency', editable: false, width: 70 },
  { name: 'locAmt', fieldName: 'locAmt', type: 'number', header: 'Amount', editable: false, width: 80, numberFormat: '#,##0' },
  {
    name: 'rcvCpltYn',
    fieldName: 'rcvCpltYn',
    type: 'text',
    header: 'Paid',
    editable: false,
    width: 60,
    renderer: {
    type: 'html',
    callback: function (grid, cell, w, h) {
      const idx = cell.index.dataRow
      const rcvCpltYn = vmAppVaAll.vaList[idx].rcvCpltYn || ''
      const apvStsCd = vmAppVaAll.vaList[idx].apvStsCd || ''
      let htmlTag = ''
      if (apvStsCd === '취소' || apvStsCd === '거절') {
         htmlTag = ''
      } else if (rcvCpltYn === '정산완료') {
        htmlTag = `<span class="label2 green">${rcvCpltYn}</span>`
      } else {
        htmlTag = `<span class="label2 red">${rcvCpltYn}</span>`
      }
      return htmlTag
    }
    }
  },
  {
    name: 'acctStsCd',
    fieldName: 'acctStsCd',
    type: 'text',
    header: '입금/미입금',
    editable: false,
    width: 60,
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
        const idx = cell.index.dataRow
        const acctStsCd = vmAppVaAll.vaList[idx].acctStsCd || ''
        const apvStsCd = vmAppVaAll.vaList[idx].apvStsCd || ''
        let htmlTag = `<span class="label2 green">${acctStsCd}</span>`
        if (apvStsCd === '취소' || apvStsCd === '거절') {
          htmlTag = ''
        } else if (acctStsCd === '미입금' || acctStsCd === '미신청') {
          htmlTag = `<span class="label2 gray">${acctStsCd}</span>`
        } else if (acctStsCd === '만료') {
          htmlTag = `<span class="label2 red">${acctStsCd}</span>`
        }
        return htmlTag
      }
    }
  },
  {
    name: 'apvStsCd',
    fieldName: 'apvStsCd',
    type: 'text',
    header: '승인상태',
    editable: false,
    width: 60,
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
        const idx = cell.index.dataRow
        const apvStsCd = vmAppVaAll.vaList[idx].apvStsCd || ''
        const reqRsps = (vmAppVaAll.vaList[idx].reqRsps) ? vmAppVaAll.vaList[idx].reqRsps.replace(/\r\n|\n|\r/g, '<br>') : '' || ''
       let html = ''
       if (apvStsCd === '거절' || apvStsCd === '처리중' || apvStsCd === '취소') {
        html = `<span class="span_tooltip">
                  <span class="label2 ${vmAppVaAll.colorMap.get(apvStsCd)}" style="text-decoration;">
                    <a onmouseover="vmAppVaAll.showTooltip(event, '${apvStsCd}')"  onmouseout="vmAppVaAll.hideTooltip(event)">
                      ${apvStsCd}
                    </a>
                  </span>`
        if (reqRsps !== '') {
           html += `<br><a style="display: block; cursor:pointer;" class="link" onclick="vmAppVaAll.reqRspsMsg(${idx})">(사유확인)</a>`
           html += `<div class="tooltip_wrap short position_absolute" 
                    style="width:250px; white-space: normal; display:none; left:-80px; top:24px; z-index: 9999;" onmouseout="vmAppVaAll.hideTooltip(event)">
                  <div class="cont">
                    <ul class="bul_list_sm t2">
                      <li>${reqRsps}</li>
                    </ul>
                  </div>
                </div>
              </span>`
         }
        } else {
          // Green label for other states
          html = `<span class="label2 ${vmAppVaAll.colorMap.get(apvStsCd)}">${apvStsCd}</span>`
        }
        return html
      }
    }
  },
  // {
  //   name: 'vaAccntCd',
  //   fieldName: 'vaAccntCd',
  //   type: 'text',
  //   header: '가상계좌관리',
  //   editable: false,
  //   width: 80,
  //   renderer: {
  //     type: 'html',
  //     callback: function (grid, cell, w, h) {
  //       const idx = cell.index.dataRow
  //       const bascNo = vmAppVaAll.vaList[idx].bascNo || ''
  //       const vaAccntCd = vmAppVaAll.vaList[idx].vaAccntCd || ''
  //       const suprInvIssNo = vmAppVaAll.vaList[idx].suprInvIssNo || ''
  //       const invIssNo = vmAppVaAll.vaList[idx].invIssNo || ''
  //       const curCd = vmAppVaAll.vaList[idx].curCd || ''
  //       const acctStsCd = vmAppVaAll.vaList[idx].acctStsCd || ''
  //       let issNo = suprInvIssNo || invIssNo
  //       const vaUsdRcvYn = vmAppVaAll.vaList[idx].vaUsdRcvYn || ''
  //       const vaKrwRcvYn = vmAppVaAll.vaList[idx].vaKrwRcvYn || ''

  //       //let issNo = invIssNo
  //       let htmlTag = ''
  //       if (vaAccntCd === '02' && acctStsCd !== '만료') {
  //         htmlTag = `<button type="button" class="button red sm" onclick="vmAppVaAll.fnVaAcctCnclYn('${bascNo}', '${issNo}', '${vaAccntCd}', '${vaKrwRcvYn}', '${vaUsdRcvYn}')">취소</button>`
  //       } else if (vaAccntCd === '03' && acctStsCd !== '만료') {
  //         htmlTag = `<button type="button" class="button blue sm" onclick="vmAppVaAll.fnVaAcctrReq('${bascNo}', '${issNo}', '${curCd}')">신청</button>`
  //       }
  //       return htmlTag
  //     }
  //   }
  // }
  {
    name: 'vaAccntCd',
    fieldName: 'vaAccntCd',
    type: 'text',
    header: '가상계좌관리',
    editable: false,
    width: 80,
    renderer: {
    type: 'html',
    callback: function (grid, cell, w, h) {
      const idx = cell.index.dataRow
      const currentRow = vmAppVaAll.vaList[idx]

      const groupRows = vmAppVaAll.vaList.filter(r =>
        r.suprInvIssNo === currentRow.suprInvIssNo &&
        r.issDt === currentRow.issDt
      )

      const firstIdxOfGroup = vmAppVaAll.vaList.findIndex(r =>
        r.suprInvIssNo === currentRow.suprInvIssNo &&
        r.issDt === currentRow.issDt
      )
      if (idx !== firstIdxOfGroup) {
        return ''
      }
      const isActive = groupRows.some(r =>
        r.apvStsCd === '요청' || r.apvStsCd === '처리중'
      )
      if (!isActive) {
        return ''
      }
      const hasAnyPaid = groupRows.some(r =>
        r.vaKrwRcvYn === 'Y' || r.vaUsdRcvYn === 'Y'
      )

      const targetRow = groupRows.find(r => r.vaAccntCd === '02') ||
                    groupRows.find(r => r.vaAccntCd === '03') ||
                    currentRow

      const bascNo = targetRow.bascNo || ''
      const vaAccntCd = targetRow.vaAccntCd || ''
      const suprInvIssNo = targetRow.suprInvIssNo || ''
      const invIssNo = targetRow.invIssNo || ''
      const curCd = targetRow.curCd || ''
      const acctStsCd = targetRow.acctStsCd || ''
      const issNo = suprInvIssNo || invIssNo
      const vaUsdRcvYn = targetRow.vaUsdRcvYn || ''
      const vaKrwRcvYn = targetRow.vaKrwRcvYn || ''

      // let htmlTag = ''
      // if (vaAccntCd === '02' && acctStsCd !== '만료') {
      //   if (!hasAnyPaid) {
      //     htmlTag = `<button type="button" class="button red sm" onclick="vmAppVaAll.fnVaAcctCnclYn('${bascNo}', '${issNo}', '${vaAccntCd}', '${vaKrwRcvYn}', '${vaUsdRcvYn}')">취소</button>`
      //   }
      // } else if (vaAccntCd === '03' && acctStsCd !== '만료') {
      //   htmlTag = `<button type="button" class="button blue sm" onclick="vmAppVaAll.fnVaAcctrReq('${bascNo}', '${issNo}', '${curCd}')">외화신청</button>`
      // }
      const usdPendingRow = groupRows.find(r => r.vaAccntCd === '03' && r.acctStsCd !== '만료')
      const krwRow = groupRows.find(r => r.vaAccntCd === '02' && r.acctStsCd !== '만료')

      let htmlTag = ''
      const buttons = []

      if (krwRow && !hasAnyPaid) {
        const issNo = krwRow.suprInvIssNo || krwRow.invIssNo
        buttons.push(`<button type="button" class="button red sm" onclick="vmAppVaAll.fnVaAcctCnclYn('${krwRow.bascNo}', '${issNo}', '02', '${krwRow.vaKrwRcvYn}', '${krwRow.vaUsdRcvYn}')">취소</button>`)
      }
      if (usdPendingRow) {
        const issNo = usdPendingRow.suprInvIssNo || usdPendingRow.invIssNo
        buttons.push(`<button type="button" class="button blue sm" onclick="vmAppVaAll.fnVaAcctrReq('${usdPendingRow.bascNo}', '${issNo}', 'USD')">외화신청</button>`)
      }

      if (buttons.length > 0) {
        htmlTag = `<div style="display:flex; flex-direction:column; gap:8px; align-items:center;">${buttons.join('')}</div>`
      }
      return htmlTag
    }
  }
}
]
export default ({
  name: 'VirtualAccountReqList',
  components: {
     EDateRangePicker: () => import('@/components/common/EDateRangePicker'),
     CombineInvoicePop: () => import('@/pages/pdf/popup/CombineInvoicePop'), /* combine Invoice */
     WinLayerPop: () => import('@/pages/trans/popup/WinLayerPop')
  },
  data () {
    return {
      accountReqList: [],
      params: {
        eiCatCd: 'O',
        dtKnd: 'VT',
        blNo: '',
        invNo: '',
        sdate: this.$ekmtcCommon.getAddDay('', -7),
        edate: this.$ekmtcCommon.getAddDay('', 7)
      },
      termType: '',
      total: 0,
      vaList: [],
      popupComponent: null,
      popupCallback: null,
      popupParams: [],
      gridHeight: 700,
      colorMap: new Map([
        ['거절', 'red'],
        ['취소', 'red'],
        ['승인', 'green'],
        ['처리중', 'gray'],
        ['요청', 'gray']
      ])
    }
  },
  created () {
    //this.init()
    console.log('this.getVaDay ()', this.getVaDay('S'))
    this.init()
  },
  beforeUnmount () {
  // 추가했던 함수와 정확히 동일한 함수를 넘겨서 제거해야 합니다.
    window.removeEventListener('message', this.handleMessage)
  },
  beforeDestroy: function () {
    window.removeEventListener('message', this.handleMessage)
  },
  mounted () {
    window.addEventListener('message', this.handleMessage)
    console.log('mounted!')
    //this.gridHeight = $('body').height() - 300
    // if (this.gridHeight < 300) {
    //   this.gridHeight = 600
    // }

    window.vmAppVaAll = this
    window.JSZip = window.JSZip || JSZip
    //리얼그리드 셋팅
    const grid = createGrid('realgrid', {
      fields,
      columns,
      header: { height: 50 },
      displayOptions: {
        fitStyle: 'evenFill',
        rowHeight: 40
      },
      editOptions: {
        editable: false,
        updatable: false
      },
      rowIndicator: { visible: false },
      stateBar: { visible: false },
      checkBar: { visible: false },
      footer: { visible: false }
    })
    gridView = grid.gridView
    provider = grid.provider

    gridView.setColumnProperty('vaAccntNo', {
    styleName: 'va-font'
    })
    /*
    gridView.columnByName('vaAccntNo').mergeRule = { criteria: 'value' }
    gridView.columnByName('issDt').mergeRule = { criteria: "values['suprInvIssNo'] + value" }
    gridView.columnByName('locAmt').mergeRule = { criteria: "values['vaAccntNo'] + values['curCd'] + value" }
    gridView.columnByName('rcvCpltYn').mergeRule = { criteria: "values['vaAccntNo'] + values['curCd'] + value" }
    gridView.columnByName('apvStsCd').mergeRule = { criteria: "values['vaAccntNo'] + values['curCd'] + value" }
    gridView.columnByName('vaAccntCd').mergeRule = { criteria: "values['suprInvIssNo'] + values['issDt']" }
    gridView.columnByName('curCd').mergeRule = { criteria: "values['vaAccntNo'] + values['curCd'] + value" }
    gridView.columnByName('acctStsCd').mergeRule = { criteria: "values['vaAccntNo'] + values['curCd'] + value" }
    gridView.columnByName('bascNo').mergeRule = { criteria: "values['suprInvIssNo'] + values['apvStsCd'] + values['issDt'] + value" }
    gridView.columnByName('invIssNo').mergeRule = { criteria: "values['suprInvIssNo'] + values['apvStsCd'] + values['issDt'] + value" }
    gridView.columnByName('apvStsCd').mergeRule = { criteria: "values['suprInvIssNo']" }
    // gridView.columnByName('vaAccntNo').mergeRule = { criteria: 'value' }
    // gridView.columnByName('locAmt').mergeRule = { criteria: "values['bascNo'] + values['invIssNo'] + value" }
    // gridView.columnByName('bascNo').mergeRule = { criteria: 'value' }
    // gridView.columnByName('apvStsCd').mergeRule = { criteria: "values['bascNo'] + value" }
    // gridView.columnByName('vaAccntCd').mergeRule = { criteria: "values['bascNo']" }
     //gridView.columnByName('rcvCpltYn').mergeRule = { criteria: "values['locAmt'] + value" }
    // gridView.columnByName('curCd').mergeRule = { criteria: "values['bascNo'] + values['locAmt'] + value" }
    gridView.columnByName('vaAccntNo').styleCallback = function (grid, dataCell) {
      var ret = {}
      if (dataCell.value) {
        ret.style = { color: 'red' }
      }
      return ret
    }
    gridView.setCopyOptions({ copyDisplayText: true, lookupDisplay: true, copyTextCallback: this.copyTextCallback })
    */
       gridView.columnByName('vaAccntNo').mergeRule = { criteria: 'value' }
    gridView.columnByName('issDt').mergeRule = { criteria: "values['suprInvIssNo'] + value" }
    gridView.columnByName('locAmt').mergeRule = { criteria: "values['vaAccntNo'] + values['curCd'] + value" }
    gridView.columnByName('rcvCpltYn').mergeRule = { criteria: "values['vaAccntNo'] + values['curCd'] + value" }
    gridView.columnByName('apvStsCd').mergeRule = { criteria: "values['vaAccntNo'] + values['curCd'] + value" }
    //gridView.columnByName('vaAccntCd').mergeRule = { criteria: "values['suprInvIssNo'] + values['issDt'] + value" }
    gridView.columnByName('vaAccntCd').mergeRule = { criteria: "values['suprInvIssNo'] + values['issDt']" }
    gridView.columnByName('curCd').mergeRule = { criteria: "values['vaAccntNo'] + values['curCd'] + value" }
    gridView.columnByName('acctStsCd').mergeRule = { criteria: "values['vaAccntNo'] + values['curCd'] + value" }
    gridView.columnByName('bascNo').mergeRule = { criteria: "values['suprInvIssNo'] + values['issDt'] + value" }
    gridView.columnByName('invIssNo').mergeRule = { criteria: "values['issDt'] + value" }
    gridView.columnByName('apvStsCd').mergeRule = { criteria: "values['suprInvIssNo'] + values['issDt']" }
    // gridView.columnByName('vaAccntNo').mergeRule = { criteria: 'value' }
    // gridView.columnByName('locAmt').mergeRule = { criteria: "values['bascNo'] + values['invIssNo'] + value" }
    // gridView.columnByName('bascNo').mergeRule = { criteria: 'value' }
    // gridView.columnByName('apvStsCd').mergeRule = { criteria: "values['bascNo'] + value" }
    // gridView.columnByName('vaAccntCd').mergeRule = { criteria: "values['bascNo']" }
     //gridView.columnByName('rcvCpltYn').mergeRule = { criteria: "values['locAmt'] + value" }
    // gridView.columnByName('curCd').mergeRule = { criteria: "values['bascNo'] + values['locAmt'] + value" }
    gridView.columnByName('vaAccntNo').styleCallback = function (grid, dataCell) {
      var ret = {}
      if (dataCell.value) {
        ret.style = { color: 'red' }
      }
      return ret
    }
    gridView.setCopyOptions({ copyDisplayText: true, lookupDisplay: true, copyTextCallback: this.copyTextCallback })
  },
  methods: {
   async init () {
      this.sdate = this.$ekmtcCommon.getAddDay('', -7).substring(0, 8)
      this.edate = this.$ekmtcCommon.getAddDay('', 7).substring(0, 8)

      const blNo = this.$route.query.blNo
      if (blNo) {
        // 정산/발행 화면에서 외화신청 목적으로 진입 → 자동취소 건너뛰고 바로 조회
        this.params.dtKnd = 'BL'
        this.params.blNo = blNo
        this.$nextTick(() => {
          this.searchData()
        })
        return // 자동취소 로직 실행 안 함
      }

      // 기존 자동취소 로직 (직접 진입한 경우에만)
      let param = { invIssNoList: [], blNo: '', cancelUno: 'SYSTEM' }
      await CalcIssue.vaAcctCancelList().then(response => {
        response.data.forEach(data => {
          param.invIssNoList.push(data.invIssNo)
          param.blNo = data.blNo
        })
      }).catch(e => { console.log(e) })

      if (param.invIssNoList.length > 0) {
        await CalcIssue.cancelSuprInvoice(param).then(response => {
          this.searchData()
        }).catch(e => { console.log(e) })
      } else {
        this.$nextTick(() => { this.searchData() })
      }
    },
    changeCalcEiCatCd () {
    //changeCalcEiCatCd
    },
    changeDateRange (s, d) {
      this.params.sdate = s
      this.params.edate = d
    },
    getVaDay (kind) {
      let today = new Date()
      let year = today.getFullYear() //연도
      let month = ('0' + (today.getMonth() + 1)).slice(-2) //월
      let date = ''
      if (kind === 'S') {
        date = ('0' + (today.getDate() - 7)).slice(-2) //날짜
      } else {
        date = ('0' + (today.getDate() + 7)).slice(-2) //날짜
      }
      return year + month + date
    },
    async searchData () {
      await vtlAcc.getfreAccList(this.params)
      .then(response => {
        console.log('getfreAccList', response)
        this.vaList = response.data.list
        provider.setRows(this.vaList)
        this.total = this.vaList.length
        }
      )
    },
    combineInvoicePopCall (blNo, eiCatCd, isExRateZero, krw, usd, invNo) {
      let invoiceData = []
      let blNoArr = []
      let invArr = []
      blNoArr = blNo.split('<br>')
      invArr = invNo.split('<br>')
      blNoArr.forEach(blNo => {
        invoiceData.push({ blNo: blNo, remark: '' })
       })
      //invoiceData.push({ blNo: blNo, remark: '' })
      const params = {
        eiCatCd: eiCatCd,
        items: invoiceData,
        chkYn: 'Y',
        isExRateZero: isExRateZero,
        invArr: invArr
      }
      this.openInvPopup('CombineInvoicePop', params)
    },
    openInvPopup (compNm, params) {
      this.popupParams = params
      this.popupComponent = compNm
      this.$ekmtcCommon.layerOpen('.inv_ongoing_list_popup')
    },
    closeInvPopup () {
      this.popupParams = {}
      this.popupComponent = null
      this.popupCallback = ''
      this.$ekmtcCommon.layerClose('.inv_ongoing_list_popup')
    },
    async fnVaAcctCnclYn (bascNo, invIssNo, vaAccntCd, vaKrwRcvYn, vaUsdRcvYn) {
      let param = {
        invIssNoList: [],
        blNo: bascNo
      }
      if (vaKrwRcvYn === 'Y' || vaUsdRcvYn === 'Y') {
        this.$ekmtcCommon.asyncAlertMessage({ message: '입금 이후에는 가상 계좌 취소 불가합니다.' })
        return
      }
      param.invIssNoList.push(invIssNo)
      if (!await this.$ekmtcCommon.asyncAlertMessage({
        message: '가상계좌를 취소하시겠습니까?',
        useConfirmBtn: true
      })) {
        return
      }
      try {
        const response = await CalcIssue.cancelSuprInvoice(param)
       if (response?.data?.rtnMsg === 'Rcv') {
          this.$ekmtcCommon.asyncAlertMessage({ message: '입금 이후에는 가상 계좌 취소 불가합니다.' })
        } else if (response?.data?.rtnMsg === 'Succ') {
          this.$ekmtcCommon.asyncAlertMessage({ message: '정상적으로 취소되었습니다.' })
        } else {
          this.$ekmtcCommon.asyncAlertMessage({ message: '가상계좌가 취소가 실패했습니다.' })
        }
        this.searchData()
      } catch (e) {
        console.log(e)
      }
    },
    async fnVaAcctrReq (bascNo, invIssNo, curCd) {
      if (!this.checkVirtualAccountTime(curCd)) {
        let msg = ''
          if (curCd === 'KRW') {
            msg = '가상계좌 신청 시간이 아닙니다.'
          } else {
            msg = '15:20 이후 외화 가상계좌 신청이 불가합니다.'
          }

          this.$ekmtcCommon.alertDefault(msg)
          return
      }
      const confirmMsg = curCd === 'USD'
      ? '외화 가상계좌를 신청하시겠습니까?'
      : '원화 가상계좌를 신청하시겠습니까?'

      if (!await this.$ekmtcCommon.asyncAlertMessage({
        message: confirmMsg,
        useConfirmBtn: true
        })) {
          return
      }

      //가상계좌 생성 여부 확인
      let isVa = 'N'
      await CalcIssue.checkVirtualAccountResult(invIssNo, 'N', 'B', curCd).then(response => {
        if (response.data === 'success') {
          isVa = 'Y'
        } else if (response.data === 'new') {
          isVa = 'A'
        } else if (response.data === 'exist') {
          isVa = 'E'
        }
      }).catch(e => {
        console.log(e)
      })
      //
      if (isVa === 'Y') {
        this.$ekmtcCommon.asyncAlertMessage({ message: '이미 가상계좌가 생성되었습니다.' })
        this.searchData()
      } else {
        //가상계좌 번호 생성 안된 경우
        //if (isVa === 'A') {
          await CalcIssue.setVirtualAccount(invIssNo)
        //}

        let TH = this
        let currency = curCd

        window.localStorage.setItem('vaBlNo', bascNo)
        window.localStorage.setItem('vaBlNoList', '')
        window.localStorage.setItem('vaInvIssNo', invIssNo)
        window.localStorage.setItem('usdYn', 'N')

        let url = '#/virtualAccount?invIssNo=' + invIssNo + '&currency=' + currency
        let option = 'width = 630, height = 600, top = 100, left = 500, location = no,scrollbars=yes'
        let popupNm = currency === 'KRW' ? 'popup_payment' : 'popup_payment_usd'
        window.open(url, popupNm, option)
      }
    },
    async handleMessage (event) {
      if (event.data === 'success') {
        //만약에 us도 있으면 가상계좌 다시 호출

        let blNo = window.localStorage.getItem('vaBlNo')

        window.localStorage.setItem('vaBlNoList', '')
        window.localStorage.setItem('vaInvIssNo', '')
        window.localStorage.setItem('usdYn', '')
        window.localStorage.setItem('vaBlNo', '')

        let date = new Date()
        let month = date.getMonth() + 1
        let day = date.getDate()
        let year = date.getFullYear()

        let rd = year + '.' + month + '.' + day + ' 17:50'
        let rdUsd = year + '.' + month + '.' + day + ' 15:30'
        let msg = '<span>가상계좌가 생성되었습니다.</span><br><br>'
            msg += '<span style="color: red; font-weight: bold;">원화입금시간 : ' + rd + '</span><br>'
            msg += '<span style="color: red; font-weight: bold;">외화입금시간 : ' + rdUsd + '</span><br>'
            msg += '<span style="color: red; font-weight: bold;">시간내 입금되지 않을 시 자동 거절 처리 됩니다.</span>'

        await this.$ekmtcCommon.asyncAlertMessage({ message: msg })

        //this.combineInvoicePopCall(blNo, 'O', false, 'C')
        this.searchData()
        //this.$emit('close')
      } else if (event.data === 'cancel') {
        let invIssNo = window.localStorage.getItem('vaInvIssNo')
        let blNo = window.localStorage.getItem('vaBlNo')

        let param = {
          invIssNoList: [invIssNo],
          blNo: blNo
        }

        /* if (!await this.$ekmtcCommon.asyncAlertMessage({
          message: '가상계좌를 취소하시겠습니까?',
          useConfirmBtn: true
        })) {
          return
        } */
        let result = await CalcIssue.cancelSuprInvoice(param)

        if (result.data.rtnMsg === 'Succ') {
          await this.$ekmtcCommon.asyncAlertMessage({ message: '정상적으로 취소되었습니다.' })
        } else {
          await this.$ekmtcCommon.asyncAlertMessage({ message: '가상계좌가 취소가 실패했습니다.' })
          return
        }

        window.localStorage.setItem('vaBlNoList', '')
        window.localStorage.setItem('vaInvIssNo', '')
        window.localStorage.setItem('usdYn', '')
        window.localStorage.setItem('vaBlNo', '')

        this.searchData()
      }
    },
    checkVirtualAccountTime (currency) {
      if (this.$ekmtcCommon.isEmpty(currency)) return

      const now = new Date()
      const targetTime = new Date()

      if (currency === 'KRW') {
        targetTime.setHours(17, 50, 0, 0)
      } else {
        targetTime.setHours(15, 20, 0, 0)
      }

      if (now.getTime() > targetTime.getTime()) {
          return false
      } else {
          return true
      }
    },
    showTooltip (e) {
      const el = e.target
      const parentEl = el.parentElement.parentElement
      parentEl.querySelector('.tooltip_wrap').style.display = 'inline-block'
    },
    tooltipTopCheck (ttId) {
      const objId = $('#' + ttId)
      const tbody = objId.parents('tbody').eq(0)
      const tr = objId.parents('tr').eq(0)
      const arrTr = tbody.find('> tr')
      const rnum = arrTr.index(tr) + 1
      const td = objId.closest('td').eq(0)
      const arrTd = tr.find('td')
      const tdIdx = arrTd.index(td)
      const width = parseInt($('#' + ttId.replace('_tt_', '_btn_')).css('width'))
      const calCnt = (arrTd.length > 14) ? 6 : 4
      const td_width = Math.round(((parseInt(td.css('width')) - width) / 2))
      if (tdIdx <= (arrTd.length - calCnt)) {
        $('#' + ttId).css({ left: (width + td_width - 3) + 'px' })
      } else {
        const orgWidth = parseInt(objId.css('width'))
        $('#' + ttId).css({ left: ((orgWidth - (width + 16)) * -1) + 'px' })
      }
      if (Math.round(arrTr.length / 2) < rnum) {
        const height = Math.round((parseInt($('#' + ttId).css('height')) / 2))
        $('#' + ttId).css({ top: ((height) * -1) + 'px' })
      }
    },
    hideTooltip (e) {
      const el = e.target
      const parentEl = el.parentElement.parentElement
      parentEl.querySelector('.tooltip_wrap').style.display = 'none'
    },
    reqRspsMsg (idx) {
      // inline handler 에 자유 텍스트를 문자열로 보간하면 따옴표·개행에서 SyntaxError 가 나므로 행 인덱스로 조회한다.
      const reqRsps = this.vaList[idx].reqRsps || ''
      this.$ekmtcCommon.alertDefault(reqRsps.replace(/\r\n|\n|\r/g, '<br>'))
    }
  }
})

</script>
<style scoped>
.popup_dim .layer_close {z-index: 2998 !important}
.popup_dim2 {z-index: 2999 !important}

.border-none {
  border : 0 !important;
}

table th, td {
    border : 0 !important;
    background: white;
}

table th, td {
    padding: 8px 0 0 10px !important;
    border : 0 !important;
    background: white;
}

.bul_list_sm li::before {
  content: none !important;
}

.input_calendar.mid, .input_calendar.mid input {
    width: 160px !important;
}

.tbl_icon.help {
    margin-bottom: 10px !important;
}

.va-font {
  font-weight: bold;
  color: #333;
}
.multi-line-css {
    white-space: pre;
}
</style>
